/**
 * Matchmaking configuration constants
 *
 * Matchmaking requests are proxied through the bQuest backend (BFF), so the
 * Care Engine URL and vector store id are no longer configured in the frontend.
 * They live server-side in the backend (CARE_ENGINE_BASE_URL / VECTOR_STORE_ID).
 */

/**
 * Number of results per page for pagination
 * Controls how many provider results are loaded per page/request
 */
export const PAGE_SIZE = 5;
